<template>
    <div class="mb-6 pr-0 lg:pr-4 text-left w-full lg:w-1/2 md:pr-0" :class="customClass">
        <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
        <select
            :id="id"
            ref="input"
            v-bind="$attrs"
            :value="modelValue"
            class="form-select bg-white"
            :class="{ error: error }"
            @input='$emit("update:modelValue", $event.target.value)'>
            <slot />
        </select>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
let id = 0
export default {
    inheritAttrs: false,
    props: {
        modelValue: [String, Number, Boolean],
        label: String,
        error: String,
        customClass: String,
    },
    beforeCreate() {
        this.id = `text-input-${id}`.toString()
        id += 1
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
    },
}
</script>
<style scoped>
.text-input-component:nth-of-type(even) {
    padding-right: 0;
}
</style>
